/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'react-router-dom';
import CTA from '../../components/Common/CTA';
import SectionTitle from '../../components/Common/SectionTitle';
import SingleProcess from '../../components/Common/Process';
import VideoStyleTwo from '../../components/Video/VideoStyleTwo';

// Service Icons (not used in category tiles)

const ServiceOneMain = () => {
    return (
        <React.Fragment>
            {/* services-area-start */}
            <div className="rs-services style2 pt-120 pb-120 md-pt-80 md-pb-80">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 offset-lg-3 text-center mb-50">
                            <h2>Business Development & Software Engineering</h2>
                            <p>Bizu LLC combines strategic business consulting with practical software and systems delivery, giving clients a complete path from market insight to execution.</p>
                        </div>
                    </div>
                    <div className="row mb-50">
                        <div className="col-lg-6">
                            <div className="category-summary">
                                <h3>Business Development</h3>
                                <p>Market analysis, strategy, partnerships, and go-to-market execution designed to help businesses grow and expand with confidence.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="category-summary">
                                <h3>IT & Software</h3>
                                <p>Custom software, cloud and DevOps, analytics, and integration services that bring your strategy to life through technology.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="category-tile text-center p-40">
                                <h3>Business Development</h3>
                                <p className="mb-20">Market analysis, strategy, partnerships, and go-to-market execution to help businesses grow.</p>
                                <Link to="/service/business-development" className="readon learn-more">Explore Business Services</Link>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="category-tile text-center p-40">
                                <h3>IT & Software</h3>
                                <p className="mb-20">Custom software, cloud & DevOps, analytics, and integrations to deliver your technical roadmap.</p>
                                <Link to="/service/it-software" className="readon learn-more">Explore IT & Software</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* services-area-end */}

            {/* process-area-start */}
            <div className="rs-process style5 bg5 pt-120 pb-120 md-pt-80 md-pb-64">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-4 md-mb-40">
                            <div className="process-wrap">
                                <SectionTitle
                                    sectionClass="sec-title mb-30"
                                    subtitleClass="sub-text new"
                                    subtitle="Working Process"
                                    titleClass="title white-color"
                                    title="Our Working Process -  How We Work For Our Customers"
                                />
                                <div className="btn-part mt-40">
                                    <Link to="/contact">
                                        <a className="readon learn-more contact-us">Contact Us</a>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 pl-30 md-pl-15">
                            <div className="row">
                                <div className="col-md-6 mb-40">
                                    <SingleProcess
                                        processNumber="1"
                                        processTitle="Discovery"
                                        processText="We meet customers in set place to discuss the details about needs and demands before proposing a plan."
                                    />
                                </div>
                                <div className="col-md-6 mb-40">
                                    <SingleProcess
                                        processNumber="2"
                                        processTitle="Concepts & Initatives"
                                        processText="Our experts come up with all kinds of ideas and initiatives for delivering the best solutions for IT services chosen."
                                    />
                                </div>
                                <div className="col-md-6 sm-mb-40">
                                    <SingleProcess
                                        processNumber="3"
                                        processTitle="Testing & Trying"
                                        processText="After agreeing on the ideas and plans, we will conduct as scheduled and give comments on the results & adaptations."
                                    />
                                </div>
                                <div className="col-md-6">
                                    <SingleProcess
                                        processNumber="4"
                                        processTitle="Execute & install"
                                        processText="Once the final plan is approved, everything will be conducted according to the agreed contract."
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* process-area-End */}

            {/* Contact Form Start */}
            <VideoStyleTwo />
            {/* Contact Form End */}

            {/* newsletter-area-start */}
            <CTA
                ctaSectionClass="rs-cta style1 cta-bg1 pt-70 pb-70"
                ctaTitleClass="epx-title"
                ctaTitle="Grow Your Business and Build Your Website or Software With us."//Team up with the best collaboration from the right expertises. 
                ctaButtonClass="readon learn-more"
                ctaButtonLink="#"
                ctaButtonText="Get In Touch"
            />
            {/* newsletter-area-end */}
        </React.Fragment>
    );
}

export default ServiceOneMain;